<template>
  <div class="main-container">

    <!-- ── Page header: title + New Quote ─────────────────────────── -->
    <div class="quotes-page-header">
      <h1><i class="file text outline icon"></i> Quotes</h1>
      <router-link :to="{name: 'NewQuote'}" class="ui primary button">New Quote</router-link>
    </div>

    <!-- ── Search ──────────────────────────────────────────────────── -->
    <div class="quotes-search-row">
      <app-text-input
        class="quotes-search-input"
        icon="search"
        placeholder="Search by number, reference or customer"
        v-model="searchText"
        @keyup="search"
      />
    </div>

    <div class="ui grid quotes-grid-wrapper">
      <div class="sixteen wide column">
        <div class="ui top attached tabular menu overflow-x-hidden">
          <button type="button" class="item active" data-tab="first" @click="tab = 'all'" @keydown.enter="tab = 'all'" @keydown.space.prevent="tab = 'all'" role="tab" :aria-selected="tab === 'all'">All ({{ counts.all }})</button>
          <button v-if="!searchText" type="button" class="item" data-tab="second" @click="tab = 1" @keydown.enter="tab = 1" @keydown.space.prevent="tab = 1" role="tab" :aria-selected="tab === 1">Drafts ({{ counts.draft }})</button>
          <button v-if="!searchText" type="button" class="item" data-tab="third" @click="tab = 2" @keydown.enter="tab = 2" @keydown.space.prevent="tab = 2" role="tab" :aria-selected="tab === 2">Sent ({{ counts.sent }})</button>
          <button v-if="!searchText" type="button" class="item" data-tab="forth" @click="tab = 3" @keydown.enter="tab = 3" @keydown.space.prevent="tab = 3" role="tab" :aria-selected="tab === 3">Accepted ({{ counts.accepted }})</button>
          <button v-if="!searchText" type="button" class="item" data-tab="sixth" @click="tab = 5" @keydown.enter="tab = 5" @keydown.space.prevent="tab = 5" role="tab" :aria-selected="tab === 5">Invoiced ({{ counts.invoiced }})</button>
          <button v-if="!searchText" type="button" class="item" data-tab="seventh" @click="tab = 6" @keydown.enter="tab = 6" @keydown.space.prevent="tab = 6" role="tab" :aria-selected="tab === 6">Declined ({{ counts.declined }})</button>
        </div>

        <!-- Tab 1 -->
        <div class="ui bottom attached tab segment active" data-tab="first">
          <div v-if="loadError && !loading" class="document-list-mobile__empty">{{ loadError }}</div>
          <document-list-view
            :rows="quoteListRows"
            :loading="loading"
            secondary-date-label="Expiry"
            @select="viewQuote($event.id)"
          />
        </div>

        <!-- Tab 2 -->
        <div class="ui bottom attached tab segment" data-tab="second">
          <document-list-view
            :rows="quoteListRows"
            :loading="loading"
            secondary-date-label="Expiry"
            @select="viewQuote($event.id)"
          />
        </div>

        <!-- Tab 3 -->
        <div class="ui bottom attached tab segment" data-tab="third">
          <document-list-view
            :rows="quoteListRows"
            :loading="loading"
            secondary-date-label="Expiry"
            @select="viewQuote($event.id)"
          />
        </div>

        <!-- Tab 4 -->
        <div class="ui bottom attached tab segment" data-tab="forth">
          <document-list-view
            :rows="quoteListRows"
            :loading="loading"
            secondary-date-label="Expiry"
            @select="viewQuote($event.id)"
          />
        </div>

        <!-- Tab 6 -->
        <div class="ui bottom attached tab segment" data-tab="sixth">
          <document-list-view
            :rows="quoteListRows"
            :loading="loading"
            secondary-date-label="Expiry"
            @select="viewQuote($event.id)"
          />
        </div>

        <!-- Tab 7 -->
        <div class="ui bottom attached tab segment" data-tab="seventh">
          <document-list-view
            :rows="quoteListRows"
            :loading="loading"
            secondary-date-label="Expiry"
            @select="viewQuote($event.id)"
          />
        </div>
      </div>

        <div class="sixteen wide column pagination-controls">
            <app-pagination
              v-if="isEmpty(pagination) === false"
              :page="pagination.page"
              :total-pages="pagination.totalPages"
              @change="getQuotes"
            />
        </div>

        <app-preview-modal v-if="previewModalVisible"
                           :parent_quote="quote"
                           :parent_quote_items="quote.items"
                           :parent_contact="quote.contact"
                           :parent_save="saveQuote"
                           @send="sendQuoteButton"
                           @duplicate="initDuplicate"
                           @option-change="onPreviewOptionChange"
                           @close="closePreview"
                           @quote="quote=$event"
                           :summary="true">
        </app-preview-modal>

        <duplicate-option-modal
          v-if="duplicateChooserVisible"
          :visible="duplicateChooserVisible"
          :option-count="(quote.options && quote.options.length) || 1"
          @close="closeDuplicateChooser"
          @cancel="closeDuplicateChooser"
          @variation="onDuplicateVariation"
          @new-quote="onDuplicateNewQuote">
        </duplicate-option-modal>

        <option-modal v-if="optionModalVisible" :content="quote" @close="optionModalVisible = false" @cancel="optionModalVisible = false; previewModalVisible = true" @email="sendModalVisible=true" @download="downloadPdf"></option-modal>

        <app-send-modal v-if="sendModalVisible"
                        :parent_quote="quote"
                        :parent_quote_items="quoteItems"
                        :parent_contact="quote.contact"
                        :parent_save="saveQuote"
                        @back="sendBackButton"
                        @close="sendModalVisible=false; optionModalVisible=false"
                        @quote="quote=$event">
        </app-send-modal>

        <app-customer v-if="customerModalVisible"
                      ref="duplicateCustomer"
                      :parent_quote="quote"
                      duplicate
                      @duplicate="duplicate"
                      @back="customerModalVisible=false; previewModalVisible=true;">
        </app-customer>
    </div>
  </div>
</template>


<script>
import auth from '../../../helpers/auth'
import preview from "../modals/preview/preview";
import moment from "moment";
import axios from "axios";
import OptionModal from "../modals/send/option";
import SendModal from "../modals/send/send";
import {isEmpty} from "lodash";
import CustomerModal from "../modals/customer/customer.vue";
import DuplicateOptionModal from "../modals/duplicate/DuplicateOptionModal.vue";
import DocumentListView from "../../common/DocumentListView.vue";
import { formatDocumentNumberShort } from "../../../helpers/documentNumberDisplay";
import { quoteDisplayTotal, quoteTotalsFromStored } from "../../../helpers/quoteTotals";
import { isQuoteStatusLocked, coerceQuoteStatusFields } from '../../../helpers/quoteStatus';
import { clone as deepClone } from '../../../helpers/clone';
import {
    DEFAULT_QUOTE_VALIDITY_DAYS,
    addDaysYmd,
    quoteValidityDaysFromSettings
} from '../../../helpers/documentDefaultDays';
import { formatDisplayDate } from '../../../helpers/displayDate';

const STATUS_DRAFT = 1
const STATUS_SENT = 2
const STATUS_ACCEPTED = 3
const STATUS_SIGNED = 4
const STATUS_INVOICED = 5
const STATUS_DECLINED = 6

export default {
    components: {
        'app-customer': CustomerModal,
        'app-preview-modal': preview,
        'app-send-modal': SendModal,
        OptionModal,
        DuplicateOptionModal,
        DocumentListView,
    },
    data: function () {
        return {
            duplicateQuoteId: null,
            duplicateChooserVisible: false,
            quotes: [],
            quote: {},
            searchText: '',
            searchResults: [],
            loading: false,
            loadError: '',
            previewModalVisible: false,
            optionModalVisible: false,
            sendModalVisible: false,
            customerModalVisible: false,
            duplicating: false,
            tab: 'all',
            quoteValidityDays: DEFAULT_QUOTE_VALIDITY_DAYS,
            pagination: {
                page: 1,
                total: 0,
                totalPages: 0,
                previousPage: 0,
                nextPage: 0,
            },
            counts: {
                all: 0,
                draft: 0,
                sent: 0,
                accepted: 0,
                invoiced: 0,
                declined: 0,
            },
        }
    },
    computed: {
        desktopQuotes: function () {
            return this.searchText ? (this.searchResults || []) : (this.quotes || [])
        },
        quoteListRows: function () {
            return (this.desktopQuotes || []).map((quote) => ({
                id: quote.id,
                source: quote,
                number: formatDocumentNumberShort(quote.number) || '-',
                customerName: quote.company || '-',
                reference: quote.reference,
                issuedDate: this.formatMobileDate(quote.date),
                secondaryDate: this.formatMobileDate(quote.due_date),
                status: quote.status_name,
                amountText: this.quoteAmountText(quote),
            }))
        }
    },
    methods: {
        isEmpty,
        moment,
        formatDocumentNumberShort,
        initDuplicate: function (quoteId) {
            this.duplicateQuoteId = quoteId;
            this.duplicateChooserVisible = true;
        },
        closeDuplicateChooser: function () {
            this.duplicateChooserVisible = false;
        },
        onDuplicateVariation: function () {
            const quoteId = this.duplicateQuoteId || (this.quote && this.quote.id);
            if (quoteId == null || quoteId === '' || String(quoteId) === 'undefined') {
                this.errorNotification && this.errorNotification('Please save the quote before adding a variation');
                this.duplicateChooserVisible = false;
                return;
            }
            const sourceId = this.quote && this.quote.active_option_id;
            this.duplicateChooserVisible = false;
            axios.post(`/quote/${quoteId}/options`, { source_option_id: sourceId || null }).then((response) => {
                const options = response.data.options || [];
                const newOpt = response.data.option;
                this.$set(this.quote, 'options', options);
                if (newOpt) {
                    this.$set(this.quote, 'active_option_id', newOpt.id);
                    this.$set(this.quote, 'active_option_index', newOpt.option_index);
                    const full = options.find((o) => o.id === newOpt.id) || newOpt;
                    if (full && Array.isArray(full.items)) {
                        this.quote.items = full.items;
                        this.quoteItems = full.items;
                    }
                }
                // Remount preview so the new option is selected in the segment control
                this.previewModalVisible = false;
                this.$nextTick(() => {
                    this.previewModalVisible = true;
                });
            }).catch((err) => {
                const msg = err.response && err.response.data && err.response.data.error
                    ? err.response.data.error
                    : 'Failed to add variation';
                this.errorNotification && this.errorNotification(msg);
                this.previewModalVisible = true;
            });
        },
        onDuplicateNewQuote: function () {
            this.duplicating = false
            this.duplicateChooserVisible = false;
            this.previewModalVisible = false;
            this.customerModalVisible = true;
        },
        duplicate: function (payload) {
            if (this.duplicating) return
            if (!payload || !payload.contact || !payload.contact.id || !this.duplicateQuoteId) {
                this.$nextTick(() => {
                    if (this.$refs.duplicateCustomer && this.$refs.duplicateCustomer.resetSubmitting) {
                        this.$refs.duplicateCustomer.resetSubmitting()
                    }
                })
                return
            }
            this.duplicating = true
            this.customerModalVisible = false
            axios.post(`/quote/${this.duplicateQuoteId}/duplicate`, {
                contact_id: payload.contact.id,
                job_id: payload.service_m8_job
            }).then(response => {
                const id = (response.data && response.data.data && response.data.data.id)
                    || (response.data && response.data.id)
                this.$router.push('/quote/' + id)
            }).catch(err => {
                this.duplicating = false
                this.customerModalVisible = true
                const msg = err.response && err.response.data && err.response.data.error
                    ? err.response.data.error
                    : 'Failed to duplicate quote'
                this.errorNotification && this.errorNotification(msg)
            })
        },
        formatQuoteAmount: function (quote) {
            if (quote && quote.amount_display) return quote.amount_display
            return this.currency(quoteDisplayTotal(quote), '$', 2)
        },
        quoteAmountText: function (quote) {
            if (quote && quote.amount_display) return quote.amount_display
            const n = Number(quote && (quote.total != null ? quote.total : quote.total_amount)) || 0
            return '$' + n.toFixed(2)
        },
        formatMobileDate: function (value) {
            return formatDisplayDate(value, '-')
        },
        sendBackButton: function () {
            this.sendModalVisible = false
            this.optionModalVisible = false
            this.previewModalVisible = true
        },
        sendQuoteButton: function () {
            this.saveQuote(false, true)
        },
        onPreviewOptionChange: function (opt) {
            if (!opt) return
            this.$set(this.quote, 'active_option_id', opt.id)
            this.$set(this.quote, 'active_option_index', opt.option_index)
            this.$set(this.quote, 'last_active_option_id', opt.id)
            if (Array.isArray(opt.items)) {
                const items = deepClone(opt.items)
                this.quote.items = items
                this.quoteItems = items
            }
            if (opt.reference !== undefined) {
                this.$set(this.quote, 'reference', opt.reference != null ? opt.reference : '')
            }
        },
        closePreview(event) {
            this.getQuotes();
            this.previewModalVisible = false;
        },
        saveQuote: function (simple = true, silent = false, forcePersistLocked = false, optionsToSave = null) {
            return new Promise((resolve, reject) => {
                if (isQuoteStatusLocked(this.quote) && !forcePersistLocked) {
                    if (!simple && this.previewModalVisible) {
                        this.previewModalVisible = false
                        this.optionModalVisible = true
                    }
                    if (!silent) {
                        this.successNotification()
                        this.$router.push('/')
                    }
                    return resolve({ quote: this.quote, quote_items: this.quote.items || [] });
                }

                if (this.quote.due_date) {
                    const dm = this.moment(String(this.quote.due_date), ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD/MM/YY'], true)
                    this.quote.valid_until = dm.isValid() ? dm.format('YYYY-MM-DD') : this.quote.due_date
                }
                if (this.quote.quote_date || this.quote.date) {
                    const raw = this.quote.quote_date || this.quote.date;
                    if (raw) {
                        const m = this.moment(String(raw), ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD/MM/YY'], true)
                        if (m.isValid()) this.quote.quote_date = m.format('YYYY-MM-DD')
                    }
                }

                const opts = Array.isArray(this.quote.options) ? this.quote.options : []
                let optionIds = Array.isArray(optionsToSave) ? optionsToSave.map((id) => Number(id)).filter(Boolean) : null
                if (optionIds && optionIds.length > 1 && this.quote.id) {
                    const activeId = Number(this.quote.active_option_id)
                    const ordered = optionIds
                        .map((id) => opts.find((o) => Number(o.id) === Number(id)))
                        .filter(Boolean)
                        .sort((a, b) => {
                            if (Number(a.id) === activeId) return 1
                            if (Number(b.id) === activeId) return -1
                            return (a.option_index || 0) - (b.option_index || 0)
                        })
                    const runSequential = (index) => {
                        const opt = ordered[index]
                        const isLast = index === ordered.length - 1
                        const payload = Object.assign({}, this.quote, {
                            items: opt.items || [],
                            reference: opt.reference != null ? opt.reference : '',
                            active_option_id: opt.id,
                            active_option_index: opt.option_index,
                            discount_mode: opt.discount_mode,
                            discount_preset_id: opt.discount_preset_id,
                            discount_title: opt.discount_title,
                            discount_description: opt.discount_description,
                            discount_type: opt.discount_type,
                            discount_value: opt.discount_value,
                            discount_amount_applied: opt.discount_amount_applied || 0,
                            total: opt.total,
                            total_amount: opt.total
                        })
                        coerceQuoteStatusFields(payload)
                        const putSilent = !isLast || silent
                        const putSimple = isLast ? simple : true
                        return axios.put('/quote/' + this.quote.id, payload).then((response) => {
                            if (isLast) {
                                const respPayload = response.data.payload || {}
                                const saved = respPayload.quote || {}
                                if (saved.reference != null) this.quote.reference = saved.reference
                                const savedOptions = respPayload.options || saved.options
                                if (Array.isArray(savedOptions) && savedOptions.length) {
                                    this.$set(this.quote, 'options', savedOptions)
                                }
                                this.quote.items = (respPayload.quote_items && respPayload.quote_items.length)
                                    ? respPayload.quote_items
                                    : (this.quoteItems || this.quote.items || [])
                                this.quoteItems = this.quote.items
                                if (!putSimple && this.previewModalVisible) {
                                    this.previewModalVisible = false
                                    this.optionModalVisible = true
                                }
                                if (!putSilent) {
                                    this.successNotification()
                                    this.$router.push('/')
                                }
                                return respPayload
                            }
                            return runSequential(index + 1)
                        })
                    }
                    return runSequential(0).then(resolve).catch(reject).finally(() => {
                        if (!silent) {
                            this.previewModalVisible = false
                            this.getQuotes()
                        }
                    })
                }

                const payload = Object.assign({}, this.quote, {
                    items: this.quote.items || this.quoteItems || [],
                    active_option_id: this.quote.active_option_id || null
                })
                coerceQuoteStatusFields(payload)
                axios.put('/quote/' + this.quote.id, payload).then(response => {
                    const payload = response.data.payload || {};
                    const saved = payload.quote || {};
                    if (saved.quote_date) this.quote.quote_date = saved.quote_date;
                    if (saved.valid_until) {
                        this.quote.valid_until = saved.valid_until;
                        this.quote.due_date = this.moment(saved.valid_until).format('YYYY-MM-DD');
                    }
                    if (saved.status) {
                        this.quote.status = saved.status;
                        const sm = { draft: 1, sent: 2, accepted: 3, rejected: 6, declined: 6, invoiced: 5 };
                        this.quote.status_id = sm[saved.status] || this.quote.status_id;
                    }
                    if (saved.reference != null) this.quote.reference = saved.reference;
                    const savedOptions = payload.options || saved.options
                    if (Array.isArray(savedOptions) && savedOptions.length) {
                        this.$set(this.quote, 'options', savedOptions)
                    }
                    if (saved.active_option_id) {
                        this.$set(this.quote, 'active_option_id', saved.active_option_id)
                    }
                    if (saved.active_option_index) {
                        this.$set(this.quote, 'active_option_index', saved.active_option_index)
                    }
                    if (Object.prototype.hasOwnProperty.call(saved, 'service_m8_job_id')) {
                        this.$set(this.quote, 'service_m8_job_id', saved.service_m8_job_id || null);
                    }
                    if (Object.prototype.hasOwnProperty.call(saved, 'service_m8_job_number')) {
                        this.$set(this.quote, 'service_m8_job_number', saved.service_m8_job_number || null);
                    }
                    if (Object.prototype.hasOwnProperty.call(saved, 'signed_by_name')) {
                        this.$set(this.quote, 'signed_by_name', saved.signed_by_name || null);
                    }
                    if (Object.prototype.hasOwnProperty.call(saved, 'signature_data')) {
                        this.$set(this.quote, 'signature_data', saved.signature_data || null);
                    }
                    if (Object.prototype.hasOwnProperty.call(saved, 'signed_at')) {
                        this.$set(this.quote, 'signed_at', saved.signed_at || null);
                    }

                    if (!simple && this.previewModalVisible) {
                        this.previewModalVisible = false
                        this.optionModalVisible = true
                    }

                    this.quote.items = (payload.quote_items && payload.quote_items.length)
                        ? payload.quote_items
                        : (this.quoteItems || this.quote.items || []);
                    this.quoteItems = this.quote.items

                    if (!silent) {
                        this.successNotification()
                        this.$router.push('/')
                    }

                    return resolve(response.data.payload);
                }).finally(() => {
                    // Silent saves (e.g. unsaved-changes → Save while switching options)
                    // must keep the preview open and only switch the active option.
                    if (!silent) {
                        this.previewModalVisible = false;
                        this.getQuotes();
                    }
                })
            })
        },
        getQuotes: function (page = 1) {
            this.loading = true
            this.loadError = ''
            this.quotes = []
            const statusMap = {
                [STATUS_DRAFT]: 'draft',
                [STATUS_SENT]: 'sent',
                [STATUS_ACCEPTED]: 'accepted',
                [STATUS_INVOICED]: 'invoiced',
                [STATUS_DECLINED]: 'rejected',
            }
            const statusValue = statusMap[this.tab] || this.tab
            const statusParam = (statusValue === 'all' || statusValue === '') ? '' : `&status=${statusValue}`
            axios.get(`/quote?page=${page}${statusParam}&_t=${Date.now()}`, {
                headers: { 'Cache-Control': 'no-cache' }
            }).then(response => {
                const data = response.data
                const rawQuotes = data && (data.quotes || (data.data && data.data.items) || [])
                if (!Array.isArray(rawQuotes)) {
                    console.warn('Quotes list: unexpected payload', data)
                    this.loadError = 'Unexpected response from /quote'
                }
                this.quotes = rawQuotes.map(q => ({
                    id: q.id,
                    number: q.number,
                    reference: q.reference || '-',
                    company: q.contact_company || q.contact_name || q.company || '-',
                    // Issued date: editable quote_date, else record created_at
                    date: q.quote_date || q.created_at || q.date,
                    due_date: q.valid_until || q.due_date || (q.created_at ? addDaysYmd(q.created_at, this.quoteValidityDays) : null),
                    status_name: q.status_name || this.statusName(q.status),
                    total: quoteDisplayTotal(q),
                    amount_display: q.amount_display || null
                }))
                const apiPagination = data.pagination || (data.data && data.data.pagination) || { page: 1, total: 0, pages: 0 }
                const page = apiPagination.page || 1
                const totalPages = apiPagination.totalPages || apiPagination.pages || Math.ceil((apiPagination.total || 0) / (apiPagination.limit || 10)) || 0
                this.pagination = {
                    page,
                    total: apiPagination.total || 0,
                    totalPages,
                    previousPage: page > 1 ? page - 1 : 0,
                    nextPage: page < totalPages ? page + 1 : 0,
                }
                if (data.counts) this.counts = Object.assign({}, this.counts, data.counts)
                this.loading = false
            }).catch((err) => {
                this.quotes = []
                const status = err && err.response && err.response.status ? err.response.status : 'unknown'
                console.warn('Quotes list fetch failed', err)
                const message = err && err.message ? err.message : ''
                this.loadError = `Failed to load quotes (${status}) ${message}`.trim()
                this.loading = false
            })
        },
        statusName: function (status) {
            const map = { 1: 'Draft', 2: 'Sent', 3: 'Accepted', 4: 'Signed', 5: 'Invoiced', 6: 'Declined', draft: 'Draft', sent: 'Sent', accepted: 'Accepted', declined: 'Declined', rejected: 'Declined', invoiced: 'Invoiced' }
            return map[status] || String(status || '')
        },
        viewQuote: function (id) {
            if (id == null || id === 'new' || String(id).trim() === '') return
            axios.get('/quote/' + id).then(response => {
                const data = response.data
                this.quote = data.quote || data
                // Ensure contact object for preview/send modal (API may include contact with email)
                const contactCompany = this.quote.contact_company || this.quote.contact_name || this.quote.company_name || ''
                this.quote.contact = this.quote.contact && this.quote.contact.id
                    ? this.quote.contact
                    : {
                        id: this.quote.contact_id,
                        email: this.quote.contact_email || '',
                        first_name: this.quote.contact_first_name || '',
                        last_name: this.quote.contact_last_name || '',
                        company: contactCompany
                    }
                // Ensure date/due_date fields are populated for preview modal
                if (!this.quote.date && this.quote.created_at) {
                    this.quote.date = this.moment(this.quote.created_at).format('YYYY-MM-DD')
                }
                if (!this.quote.due_date) {
                    if (this.quote.valid_until) {
                        this.quote.due_date = this.moment(this.quote.valid_until).format('YYYY-MM-DD')
                    } else {
                        this.quote.due_date = this.quote.created_at
                            ? addDaysYmd(this.quote.created_at, this.quoteValidityDays)
                            : null
                    }
                }
                // Map status string to numeric status_id for preview modal dropdown
                coerceQuoteStatusFields(this.quote)
                if (!this.quote.status_id && this.quote.status) {
                    const statusMap = { draft: STATUS_DRAFT, sent: STATUS_SENT, accepted: STATUS_ACCEPTED, declined: STATUS_DECLINED, rejected: STATUS_DECLINED, invoiced: STATUS_INVOICED }
                    this.quote.status_id = statusMap[this.quote.status] || this.quote.status_id
                }
                // Ensure terms field is set from notes if present
                if (!this.quote.terms && this.quote.notes) {
                    this.quote.terms = this.quote.notes
                }
                // Ensure totals are set for preview modal (stored totals are GST-inclusive)
                if (this.quote.total_amount != null || this.quote.total != null) {
                    const storedTotals = quoteTotalsFromStored(this.quote)
                    this.quote.sub_total = storedTotals.sub_total
                    this.quote.gst_total = storedTotals.gst_total
                    this.quote.total = storedTotals.total
                }
                this.quote.discount_override = (data.quote || data).discount_amount_applied || (data.quote || data).discount || 0
                this.quote.discount_mode = (data.quote || data).discount_mode || null
                this.quote.discount_preset_id = (data.quote || data).discount_preset_id || null
                this.quote.discount_title = (data.quote || data).discount_title || null
                this.quote.discount_description = (data.quote || data).discount_description || null
                this.quote.discount_type = (data.quote || data).discount_type || null
                this.quote.discount_value = (data.quote || data).discount_value || null
                this.quote.discount_amount_applied = (data.quote || data).discount_amount_applied || 0
                this.quoteItems = this.quote.items || []
                this.previewModalVisible = true
            }).catch(() => {})
        },
        downloadPdf: function () {
            const isDraft = this.quote.status_id === 1 || this.quote.status_id === '1' || this.quote.status === 'draft'
            if (isDraft) {
                this.quote.status_id = STATUS_SENT
                this.quote.status = 'sent'
            }
            this.optionModalVisible = false
            const optIdx = this.quote.active_option_index || 1
            const fetchPdf = () => axios.get('/quote/' + this.quote.id + '/pdf', { responseType: 'blob', params: { option: optIdx } })

            // Accepted / declined / invoiced quotes are locked — download without PUT (status stays put).
            const pdfPromise = isQuoteStatusLocked(this.quote)
                ? fetchPdf()
                : (() => {
                    if (this.quote.due_date) this.quote.valid_until = this.quote.due_date
                    const payload = Object.assign({}, this.quote)
                    coerceQuoteStatusFields(payload)
                    return axios.put('/quote/' + this.quote.id, payload).then(() => fetchPdf())
                })()

            pdfPromise.then(response => {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                const a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                a.href = fileURL;
                a.download = `${this.quote.number}-${optIdx}.pdf`;
                a.click();
                window.URL.revokeObjectURL(fileURL);
                this.swal({ type: 'success', title: 'Quote downloaded' }).then(() => {
                    if (this.$route.path !== '/') {
                        this.$router.push('/').catch(function () {});
                    }
                });
            }).catch(err => {
                this.errorNotification(err.response && err.response.data && err.response.data.error ? err.response.data.error : (err.message || 'Download failed'));
            }).finally(() => {
                this.getQuotes();
            });
        },
        search: function () {
            if (this.searchText && this.searchText.length >= 2) {
                axios.post('/quote/fetch/search', {text: this.searchText}).then(response => {
                    const data = response.data
                    const raw = data.quotes || (Array.isArray(data) ? data : [])
                    this.searchResults = raw.map(q => ({
                        id: q.id,
                        number: q.number,
                        reference: q.reference || '-',
                        company: q.contact_company || q.contact_name || q.company || '-',
                        date: q.quote_date || q.created_at || q.date,
                        due_date: q.valid_until || q.due_date || (q.created_at ? addDaysYmd(q.created_at, this.quoteValidityDays) : null),
                        status_name: q.status_name || this.statusName(q.status),
                        total: quoteDisplayTotal(q),
                        amount_display: q.amount_display || null
                    }))
                }).catch(() => {
                    this.searchResults = []
                })
            } else {
                this.searchResults = []
            }
        }
    },
    created: function () {
        /**
         * Component requires authentication, check if user is authenticated
         */
        auth.check(this)
        axios.get('/api/setting/display').then(response => {
            this.quoteValidityDays = quoteValidityDaysFromSettings(response.data)
        }).catch(() => {})
    },
    mounted: function () {
        this.getQuotes()

        /**
         * Initialise Semantic UI tabs
         */
        $(this.$el).find('.ui.menu .item').tab()
    },

    watch: {
        tab: function (val) {
            this.getQuotes()
        }
    }
}
</script>

<style scoped>
.quotes-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.quotes-page-header h1 {
  margin: 0;
}

.quotes-page-header .ui.primary.button {
  margin-right: 0;
}

.quotes-search-row {
  margin-bottom: 12px;
}

.quotes-search-row .smardie-text-input input {
  height: 44px !important;
  line-height: 44px !important;
}

.quotes-grid-wrapper.ui.grid {
  margin: 0 !important;
}

.quotes-grid-wrapper.ui.grid > .column {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.quotes-grid-wrapper .ui.bottom.attached.tab.segment {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (max-width: 767px) {
  .quotes-page-header h1 {
    font-size: 1.5em;
  }
}
</style>
